//import Libraries
import React, { Component } from 'react'
import { connect } from 'react-redux';

//import Components
import { Modal, Button } from 'reactstrap';
import Language from '../../language/language.json';
import Icons from '../../assets/icons/icons';

//import Style classes
// import './SignIn.css'

const logoIcon = Icons.logo

class NotLoggedIn extends Component {

    render() {
        const {language} = this.props.universal

        return (
            <div>
                <Modal 
                    isOpen={this.props.modal} 
                    toggle={this.props.toggle}
                    onClosed={this.props.onClosed}
                >
                    <div className="SigninContainer">
                        <div className="Logo">{logoIcon}</div>
                        <div className="Title">
                            {Language.notLoggedIn.title[language]}
                        </div>
                        <form>
                            <div className="content">
                                <div>
                                    <p>
                                        {Language.notLoggedIn.content[language]}
                                    </p>
                                </div>
                                <div className="element">
                                    <Button 
                                        size="lg"
                                        color="info"
                                        className="btn"
                                        onClick={this.props.onToSignInClick}
                                    >
                                        {Language.notLoggedIn.button[language]}
                                    </Button>
                                </div>
                            </div>
                        </form>
                        <hr/>
                        <div className="footer">
                            <span
                                onClick={this.props.onToSignUpClick}
                            >
                                {Language.notLoggedIn.signUp[language]}
                            </span>
                        </div>

                    </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state)=>{
    return {
        universal : state.universal,
    }
}

// const mapDispatchToProps = (dispatch, ownProps)=>{
//     return {
//         onResetAuth : () => {
//             dispatch({ type: 'RESET_AUTH' })
//         },
//         onSignIn : (email, password)=> {
//             dispatch(signInActions.signIn(email, password))
//         },
//     }
// }

export default connect(mapStateToProps, null)(NotLoggedIn);



// WEBPACK FOOTER //
// ./src/components/NotLoggedIn/NotLoggedIn.js